export default class DocumentPaymentTypes {
  static BUY = "buy";

  static SELL = "sell";
}
